import React from 'react'
import { BatchStop, BatchNum, BatchAll, BatchOptions } from 'component'
import { isPermissions } from 'meinian-package/src//utils/auth'

export default ({
  batchAll,
  cancelBatch,
  $masonry,
  info,
  auth,
}) => <div className="screen-wrap-item">
  <div className="meinian-space" />
  <BatchAll style={{ margin: '0 24px' }} keyValues={batchAll.map(m => `${m.imageGroupEntityId},${m.inspirationId}`)} infos={batchAll} />
  <BatchNum style={{ marginRight: 40 }} />
  <BatchOptions.Collect data={batchAll} onChange={() => { cancelBatch(); $masonry.current?.init() }} />
  <div className="batch-operation-wrap">
    {isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) ? <BatchOptions.MoveImages
      onChange={() => { cancelBatch(); $masonry.current?.init() }}
      lajiInspirationId={info.id}
    /> : null}
    <BatchOptions.Download fileName={info.name} onChange={() => { cancelBatch() }} />
    {(!auth.includes('F02') && !auth.includes('FC03')) ? null : <BatchOptions.Export fileName={info.name} onChange={() => { cancelBatch() }} />}
    {(!isPermissions(auth, ['FS03', 'FS03_CREATOR', 'FCS03', 'FCS03_CREATOR']) && !batchAll?.every(item => item.ownerStatus === 1)) ? null : <BatchOptions.Delete onChange={() => { cancelBatch(); $masonry.current?.init() }} />}
  </div>
  <BatchStop onClick={() => cancelBatch()} />
</div>
